var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (stores, unit) {pug_html = pug_html + "\u003Cdiv data-list-output\u003E\u003Ctable class=\"table table-zebra\"\u003E\u003Ctbody\u003E";
// iterate stores
;(function(){
  var $$obj = stores;
  if ('number' == typeof $$obj.length) {
      for (var key = 0, $$l = $$obj.length; key < $$l; key++) {
        var store = $$obj[key];
let activeClass = key === 0 ? 'color-primary' : 'color-default'
const { storeName, quantity } = store
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes([activeClass], [true]), false, true)) + "\u003E\u003Ctd class=\"align-left\"\u003E" + (pug.escape(null == (pug_interp = storeName) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"align-right\"\u003E" + (pug.escape(null == (pug_interp = quantity) ? "" : pug_interp)) + " " + (pug.escape(null == (pug_interp = unit) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var key in $$obj) {
      $$l++;
      var store = $$obj[key];
let activeClass = key === 0 ? 'color-primary' : 'color-default'
const { storeName, quantity } = store
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes([activeClass], [true]), false, true)) + "\u003E\u003Ctd class=\"align-left\"\u003E" + (pug.escape(null == (pug_interp = storeName) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"align-right\"\u003E" + (pug.escape(null == (pug_interp = quantity) ? "" : pug_interp)) + " " + (pug.escape(null == (pug_interp = unit) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E";}.call(this,"stores" in locals_for_with?locals_for_with.stores:typeof stores!=="undefined"?stores:undefined,"unit" in locals_for_with?locals_for_with.unit:typeof unit!=="undefined"?unit:undefined));;return pug_html;};
module.exports = template;